import * as React from 'react';

function tintColor(color, percent) {
  percent = Math.max(-100, Math.min(100, percent));

  let hex = color.replace('#', '');
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  r = Math.round(r * (1 + percent / 100));
  g = Math.round(g * (1 + percent / 100));
  b = Math.round(b * (1 + percent / 100));

  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  let hexR = r.toString(16).padStart(2, '0');
  let hexG = g.toString(16).padStart(2, '0');
  let hexB = b.toString(16).padStart(2, '0');

  return `#${hexR}${hexG}${hexB}`;
}

const SubscriptionBox = (props) => {
  return (
    <svg width={152} height={150} viewBox="0 0 152 150" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M38.0457 24.3845C38.0457 24.3845 60.9163 41.7397 95.6856 9.28835C126.564 -19.5315 151.777 25.9397 151.953 47.715C152.182 75.923 121.075 98.4926 136.171 117.02C151.267 135.548 106.233 166.142 81.9618 139.664C51.7695 106.727 43.5898 133.489 26.3805 133.489C14.0291 133.489 -11.3297 102.799 5.79483 79.9659C20.2048 60.7526 12.3461 54.376 8.53952 47.715C3.05006 38.1083 16.0877 12.0331 38.0457 24.3845Z"
        fill={tintColor(props.bg, -24)}
      />
      <path d="M75.0511 63.8479V128.252L25.0469 106.653L25.2854 42.4824L75.0511 63.8479Z" fill={tintColor(props.color, -40)} />
      <path d="M75.0469 63.8858V128.29L124.808 107.437V42.6875L75.0469 63.8858Z" fill={tintColor(props.color, 5)} />
      <path d="M75.0511 63.8467L125.055 42.9025L75.4438 20.9111L25.0469 42.3789L75.0511 63.8467Z" fill={tintColor(props.color, -10)} />
      <path
        d="M43.8984 34.3478L93.7119 56.0297L94.1644 71.83L108.102 66.0792L107.68 50.1792L56.393 29.0254L43.8984 34.3478Z"
        fill={tintColor(props.color, -40)}
      />
      <path
        d="M90.867 86.9928C91.6565 86.9928 92.2966 85.8246 92.2966 84.3836C92.2966 82.9426 91.6565 81.7744 90.867 81.7744C90.0775 81.7744 89.4375 82.9426 89.4375 84.3836C89.4375 85.8246 90.0775 86.9928 90.867 86.9928Z"
        fill="white"
      />
      <path
        d="M113.906 77.609C114.696 77.609 115.336 76.4408 115.336 74.9998C115.336 73.5588 114.696 72.3906 113.906 72.3906C113.117 72.3906 112.477 73.5588 112.477 74.9998C112.477 76.4408 113.117 77.609 113.906 77.609Z"
        fill="white"
      />
      <path
        d="M99.1626 100.767L98.2344 100.407C100.291 95.1116 102.87 92.1946 105.9 91.7366C108.799 91.2985 111.24 93.2954 112.126 94.4124L111.346 95.0311C110.733 94.2584 108.588 92.3376 106.049 92.7212C103.435 93.1161 101.054 95.8984 99.1626 100.767Z"
        fill="white"
      />
    </svg>
  );
};
export default SubscriptionBox;
